///<reference path='../../../core/directives/AutocompleterField.ts'/>
'use strict';
/*
    Creates an airport multi select field.
    Selectable options are exposed as `ac.data`.
*/
namespace Autocompleter {

    class AirportMultiSelectUnified extends AutocompleterField {

        private available: any[] = [];
        private selectAttrFn: (item: any) => void;
        private isCodeSelected: (code: string) => boolean =
            (code: string) => _.find(this.currentValue, v => code === v.Code);

        prefilled: string;
        notActive: boolean;
        _placeholder: string;

        constructor (
            public $scope: any,
            public $route: ng.route.IRouteService,
            public autocompleter: any,
            public resourceService: Core.ResourceService,
            public $q: ng.IQService,
            public $timeout: ng.ITimeoutService,
            private destinationService: any
        ) {
            super();
            if (_.isEmpty(this.areaOverride)) {
            	this.areaOverride = 'flights';
            }
            this.$scope.$watch('ac.currentValue', v => {
                if (v) {
                    this._refreshData();
                }
            });

            // Wrap `select` attribute fn
            this.selectAttrFn = this.select;
            this.select = (item) => {
                this.selectItem(item);
                this.selectAttrFn({items: this.currentValue});
            };

            if(this.prefilled != null && this.prefilled !== '') {
                this.prefill(this.prefilled);
            } else if (this.getArea() === 'flights-departure') {
                this.autocompleter.initialDepartureAirports().then(result => this.update(result));
            }
        }

        private prefill(data) {
            let prefill = data.split(/\s*,\s*/);
            this.prefix = data;
            this.fetch().then(() => {
                prefill.forEach(code => {
                    this.available.forEach(item => {
                        if(item.Code === code) {
                            this.select(item);
                        }
                    });
                });
            });
        }

        set placeholder(placeholder) {
            if(!this.notActive) {
                this._placeholder = placeholder;
            } else {
                this._placeholder = this.resourceService.get('DEFAULTAIRPORT');
            }
        }

        get placeholder() {
            return this._placeholder;
        }

        update (result: any): void {
            // Called by super._fetch() with autocompleter.lookup result
            this.available = result.data;
            this._refreshData();

            if (_.isEmpty(this.data) && !this.notActive) {
                this.data = null;
                this.$scope.$emit('flash:error', this.resourceService.get('NOMATCHES'));
            }
        }

        selectItem (item: any): void {
            if (item && item.Code) {
                // Add codes which are not already selected
                let codes = item.Code.split(',');
                _.forEach(codes, (code: string) => {
                    if(!this.isCodeSelected(code)) {
                        if(!this.currentValue) {
                            this.currentValue = [];
                        }
                        this.currentValue.push({Code: code, Title: item.Title});
                    }
                });
                this.prefix = '';
                this._refreshData();
            }
        }

        removeItem (item: any): void {
            if (!item) { return; }
            this.currentValue.splice(this.currentValue.indexOf(item), 1);

            if (!this.currentValue.length) {
                this.deselect();
            }
            else {
                this.selectAttrFn({items: this.currentValue});
            }
            this._refreshData();
        }

        blur () {
            this.$timeout(() => {
                if (this.prefix) {
                    var firstItem = _.find(this.data || [], d => !d.header);
                    if (firstItem) {
                        this.select(firstItem);
                    }
                }
            }, 200);
        }

        firstTitle() {
            if (!this.$scope.extraFocusTrackerFocused) {
                if (this.currentValue && this.currentValue[0]) {
                    return this.getTitle(this.currentValue[0]);
                }
            }
        }
        titleCache = {};
        getTitle(airport) {
            if (airport.Code in this.titleCache) {
                return this.titleCache[airport.Code];
            }
            if (airport.Title) {
                return this.titleCache[airport.Code] = this.formatTitle(airport.Title);
            }
            this.destinationService
                .getAirport(airport.Code)
                .then(airport => this.titleCache[airport.Code] = this.formatTitle(airport.Title));
            return this.titleCache[airport.Code] = ' ';
        }

        formatTitle(title) {
            return (title || '').split('(')[0].split(',')[0];
        }

        private _refreshData (): void {
            this.data = this.addHeader(this._getAvailable(), 'AIRPORTS');
        }

        private _getAvailable () : any[]  {
            // Filters out items where all codes are already selected
            return _.reject(
                this.available,
                item => _.every(
                    item.Code.split(','),
                    this.isCodeSelected
                )
            );
        }
    }

    angular
        .module('TR')
        .directive('airportMultiSelectUnified', (): ng.IDirective => {
            return {
                restrict: 'E',
                replace: false,
                scope: {},
                controllerAs: 'ac',
                bindToController: {
                    placeholder: '@',
                    select: '&',
                    deselect: '&',
                    currentValue: '=',
                    focusTracker: '=',
                    minPrefix: '@',
                    notActive: '=',
                    prefilled: '@',
                    disabled: '@',
                    areaOverride: '@'
                },
                templateUrl: 'partials/home/directivetemplate?type=AirportMultiSelectUnified',
                controller: AirportMultiSelectUnified,
                transclude: true,
                link: (
                    scope: any,
                    el: JQuery
                ) => {
                    scope.ac.inputField = el.find('input');
                }
            };
        });
}
